/**
 * Application transfer protocol — framed messages carried INSIDE the encrypted
 * SecureChannel (so the wire only ever shows AEAD ciphertext).
 *
 * Each plaintext frame is: [1 type byte][payload].
 *   - FRAME_CONTROL: payload is UTF-8 JSON (a `Control` message).
 *   - FRAME_CHUNK:   payload is raw file bytes for the current transfer.
 *
 * Transfers in a given direction are sequential, so chunks unambiguously belong
 * to the most recently accepted offer.
 */

export const FRAME_CONTROL = 0x01;
export const FRAME_CHUNK = 0x02;

export interface FileOffer {
  t: "offer";
  id: string;
  name: string;
  size: number;
  mime: string;
}
export interface FileAccept {
  t: "accept";
  id: string;
}
export interface FileDecline {
  t: "decline";
  id: string;
}
export interface FileEnd {
  t: "end";
  id: string;
}
export interface FileError {
  t: "error";
  id: string;
  message: string;
}

export type Control =
  | FileOffer
  | FileAccept
  | FileDecline
  | FileEnd
  | FileError;

const encoder = new TextEncoder();
const decoder = new TextDecoder();

export function encodeControl(control: Control): Uint8Array {
  const json = encoder.encode(JSON.stringify(control));
  const out = new Uint8Array(1 + json.length);
  out[0] = FRAME_CONTROL;
  out.set(json, 1);
  return out;
}

export function encodeChunk(data: Uint8Array): Uint8Array {
  const out = new Uint8Array(1 + data.length);
  out[0] = FRAME_CHUNK;
  out.set(data, 1);
  return out;
}

export function decodeFrame(bytes: Uint8Array): {
  type: number;
  payload: Uint8Array;
} {
  return { type: bytes[0], payload: bytes.subarray(1) };
}

export function decodeControl(payload: Uint8Array): Control {
  return JSON.parse(decoder.decode(payload)) as Control;
}
